"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// my tests in ie11/chrome/FF indicate that keyDown repeats
// at about 35ms+/- 5ms after an initial 500ms delay. callback fires on the leading edge
function Repeater(callback) {
    var id, cancel = function () { return clearInterval(id); };
    id = setInterval(function () {
        cancel();
        id = setInterval(callback, 35);
        callback(); //fire after everything in case the user cancels on the first call
    }, 500);
    return cancel;
}
exports.Repeater = Repeater;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/number-spinner/repeater.js
// module id = 576
// module chunks = 0 1 2 3 4 5 6